import { headlineExSmall, Loading, ModalPopup } from '@aon/aon-tws-common-ui';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { ISurveyQuestionEditModel, SurveyStep } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators } from '../../store/QuestionChangesStore';
import { LoadingWrapper } from '../common';
import { BodyCopyLink } from '../common/styles/globalStyles';
import { ErrorWarningDisplay } from '../common/summary-item/ErrorWarningDisplay';
import { QuestionChangesModalContentContainer } from '../questions/question-changes/QuestionChangesModalContent';

export const ModalContentTitle = styled.p`
	${headlineExSmall}
`;

export interface IQuestionViewUpdateButtonProps {
	isSummary: boolean;
	isSurveyAdmin?: boolean;
	question: ISurveyQuestionEditModel;
}

export function QuestionViewUpdateButton(props: IQuestionViewUpdateButtonProps) {
	const [isQuestionChangesModalOpen, SetIsQuestionChangesModalOpen] = useState<boolean>(false);
	const questionChanges = useSelector((state: IApplicationState) => state.questionChanges);
	const dispatch = useDispatch();

	function getViewUpdateButtonForDefine() {
		const { question } = props;
		return (
			<>
				{question.hasUpdates && !question.syncWithQuestionLibrary && (
					<BodyCopyLink onClick={toggleQuestionChangesModal}>{ContentConstants.QUESTION_CHANGES_VIEW_UPDATE}</BodyCopyLink>
				)}

				{isQuestionChangesModalOpen && getQuestionChangesModal()}
			</>
		);
	}
	function getViewUpdateButtonForSummary() {
		const { isSurveyAdmin } = props;
		return isSurveyAdmin ? (
			<></>
		) : (
			<ErrorWarningDisplay
				errors={[]}
				warnings={[
					{
						message: ContentConstants.QUESTION_CHANGES_UPDATE_AVAIABLE_TEXT,
						relatedStep: SurveyStep.Define,
					},
				]}
			/>
		);
	}

	function getQuestionChangesModal() {
		const { question } = props;
		return (
			<ModalPopup
				isOpen={isQuestionChangesModalOpen}
				title={ContentConstants.QUESTION_CHANGES_MODAL_TITLE}
				contentfullwidth={true}
				contenthcentered={true}
				primaryButtonText={'Update'}
				secondaryButtonText={'Cancel'}
				primaryButtonDisabled={!questionChanges.questionChange}
				onClosed={onCloseModal}
				onSubmit={onModalSubmit}
			>
				{questionChanges.isSingleQuestionChangesLoading ? (
					<LoadingWrapper>
						<Loading height={'70px'} width={'70px'} />
					</LoadingWrapper>
				) : (
					<div>
						<ModalContentTitle>{ContentConstants.QUESTION_CHANGES_MODAL_CONTENT_TITLE}</ModalContentTitle>
						<p>{ContentConstants.QUESTION_CHANGES_MODAL_CONTENT_PRETEXT}</p>

						<QuestionChangesModalContentContainer question={question} questionChange={questionChanges.questionChange!} />
					</div>
				)}
			</ModalPopup>
		);
	}

	function onModalSubmit() {
		const { question } = props;
		SetIsQuestionChangesModalOpen(false);
		dispatch(
			ActionCreators.SyncSingleSurveyQuestionChanges({
				...questionChanges.questionChange!.question,
				surveyQuestionId: question.surveyQuestionId,
			}),
		);
	}

	function onCloseModal() {
		SetIsQuestionChangesModalOpen(false);
	}

	function toggleQuestionChangesModal() {
		const { question } = props;
		SetIsQuestionChangesModalOpen(true);
		dispatch(ActionCreators.GetSurveySingleQuestionChanges(question.surveyQuestionId!, true));
	}

	const { isSummary } = props;
	return <>{isSummary ? getViewUpdateButtonForSummary() : getViewUpdateButtonForDefine()}</>;
}
